enum EUserProvider {
  MALE_APPLICATION = 'MALE_APPLICATION',
  MANAGEMENT_APPLICATION = 'MANAGEMENT_APPLICATION',
}

enum ESystemMobile {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  OTHER = 'OTHER',
}

enum EContentSectionType {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
  FILE = 'file',
  RICH_MESSAGE = 'richMessage',
  CARD_TYPE_MESSAGE = 'cardTypeMessage',
  SURVEY = 'survey',
}

enum EUrlButtonType {
  IMAGE_URL = 'imageUrl',
  VIDEO_URL = 'videoUrl',
}

enum ESendRecipient {
  ALL = 'all',
  FILTER = 'filter',
  /** タグが1つも付いていない友だち */
  UNTAGGED = 'untagged',
}

enum ESendTime {
  IMMEDIATE = 'immediate',
  SCHEDULED = 'scheduled',
}

enum EMoveDirection {
  UP = 'up',
  DOWN = 'down',
}

enum ELineChannelStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  FULL = 'FULL',
  UNLINKED = 'UNLINKED',
}

enum ELineWebhookStatus {
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
  INVALID = 'INVALID',
}

// LINEチャンネルが PAUSED になった経緯。status=PAUSED のときだけ意味を持つ。
// HEALTH_CHECK はヘルスチェック/送信時の401・403による自動停止（BAN/凍結の疑い）、
// MANUAL は人手による停止とWebhook未有効による自動停止。
enum EPausedBy {
  MANUAL = 'MANUAL',
  HEALTH_CHECK = 'HEALTH_CHECK',
}

enum EOrganizationMemberRole {
  ADMIN = 'ADMIN',
  STANDARD = 'STANDARD',
}

enum EOrganizationMemberStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
}

enum EOrganizationPlan {
  LIGHT = 'LIGHT',
  BASIC = 'BASIC',
  INTERNAL = 'INTERNAL',
}

// 組織ごとにON/OFFできる利用機能。値はバックエンドの features のキーと一致させる。
enum EOrganizationFeature {
  TAG_MANAGEMENT = 'tagManagement',
  BULK_SEND_TAGGING = 'bulkSendTagging',
  SURVEY = 'survey',
  STEP_DELIVERY = 'stepDelivery',
}

enum ERichMenuAreaActionType {
  None = 'none',
  Uri = 'uri',
  Message = 'message',
  Survey = 'survey',
}

enum ERichMenuImageContentType {
  Png = 'image/png',
  Jpeg = 'image/jpeg',
  Jpg = 'image/jpg',
}

enum ERichMenuImageFieldLayout {
  Stacked = 'stacked',
  Row = 'row',
}

enum ERichMenuTemplateCategory {
  Large = 'large',
  Compact = 'compact',
}

export {
  EUserProvider,
  ESystemMobile,
  EContentSectionType,
  EUrlButtonType,
  ESendRecipient,
  ESendTime,
  EMoveDirection,
  ELineChannelStatus,
  ELineWebhookStatus,
  EPausedBy,
  EOrganizationMemberRole,
  EOrganizationMemberStatus,
  EOrganizationPlan,
  EOrganizationFeature,
  ERichMenuAreaActionType,
  ERichMenuImageContentType,
  ERichMenuImageFieldLayout,
  ERichMenuTemplateCategory,
};
